import styled from "styled-components";

export const Wrapper = styled.div`
  --mu-primary: #f45b68;
  --mu-primary-soft: rgba(244, 91, 104, 0.1);
  --mu-primary-border: rgba(244, 91, 104, 0.35);
  --mu-hero-bg: linear-gradient(145deg, #1e1e2d 0%, #151521 100%);
  --mu-shadow: 0 8px 30px rgba(24, 28, 50, 0.08);
  --mu-radius: 0.85rem;
  --mu-radius-sm: 0.55rem;

  [data-bs-theme="dark"] & {
    --mu-primary-soft: rgba(244, 91, 104, 0.16);
    --mu-primary-border: rgba(244, 91, 104, 0.45);
    --mu-hero-bg: linear-gradient(145deg, #2b2b40 0%, #1e1e2d 100%);
    --mu-shadow: 0 8px 30px rgba(0, 0, 0, 0.28);
  }

  /* ── List page ───────────────────────────────────── */
  .mu-page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  .mu-page-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: var(--app-text);
    margin: 0 0 0.35rem;
    letter-spacing: -0.02em;
  }

  .mu-page-subtitle {
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--app-text-muted);
    margin: 0;
    max-width: 520px;
  }

  .mu-invite-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.65rem 1.25rem;
    border: none;
    border-radius: var(--mu-radius-sm);
    background: var(--mu-primary);
    color: #fff;
    font-size: 0.875rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
    box-shadow: 0 4px 14px rgba(244, 91, 104, 0.28);
  }

  .mu-invite-btn:hover {
    background: #e04a57;
    transform: translateY(-1px);
  }

  .mu-search-wrap {
    background: var(--app-surface);
    border-radius: var(--mu-radius-sm);
  }

  .mu-search-input {
    color: var(--app-text) !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  .mu-search-icon {
    color: var(--app-text-muted);
  }

  [data-bs-theme="dark"] & .mu-search-input {
    color: #ffffff !important;
  }

  [data-bs-theme="dark"] & .mu-search-input::placeholder {
    color: #92929f !important;
  }

  .mu-table-card {
    border: 1px solid var(--app-border);
    border-radius: var(--mu-radius);
    background: var(--app-surface);
    box-shadow: var(--mu-shadow);
    overflow: hidden;
  }

  .mu-user-cell {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .mu-user-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: var(--mu-primary-soft);
    color: var(--mu-primary);
    font-weight: 800;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mu-user-name {
    font-weight: 700;
    color: var(--app-text);
    line-height: 1.2;
  }

  .mu-user-email {
    font-size: 0.8rem;
    color: var(--app-text-muted);
  }

  .mu-role-tag {
    display: inline-flex;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    background: var(--app-surface-alt);
    border: 1px solid var(--app-border);
    color: var(--app-text-muted);
  }

  .mu-role-tag--admin {
    background: rgba(114, 57, 234, 0.1);
    border-color: rgba(114, 57, 234, 0.3);
    color: #7239ea;
  }

  .mu-role-tag--manager {
    background: rgba(0, 158, 247, 0.1);
    border-color: rgba(0, 158, 247, 0.3);
    color: #009ef7;
  }

  .mu-role-tag--analyst {
    background: var(--mu-primary-soft);
    border-color: var(--mu-primary-border);
    color: var(--mu-primary);
  }

  .mu-status-pill {
    display: inline-flex;
    padding: 0.2rem 0.5rem;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 700;
  }

  .mu-status-pill--active {
    background: rgba(80, 205, 137, 0.12);
    color: #50cd89;
  }

  .mu-status-pill--pending {
    background: rgba(255, 199, 0, 0.14);
    color: #b8860b;
  }

  .mu-status-pill--disabled {
    background: rgba(181, 181, 195, 0.18);
    color: #7e8299;
  }

  [data-bs-theme="dark"] & .mu-status-pill--active {
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .mu-status-pill--pending {
    color: #ffc700;
  }

  [data-bs-theme="dark"] & .mu-status-pill--disabled {
    color: #a1a5b7;
  }

  .mu-action-btn {
    color: var(--app-text-muted) !important;
  }

  .mu-action-btn:hover {
    color: var(--mu-primary) !important;
  }

  .mu-table-header-row {
    color: var(--app-text) !important;
  }

  .mu-page-table tbody td {
    color: var(--app-text);
    border-bottom-color: var(--app-border);
  }

  .manage-users-search-input {
    color: var(--app-text) !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  [data-bs-theme="dark"] & .manage-users-search-input {
    color: #ffffff !important;
  }

  [data-bs-theme="dark"] & .manage-users-search-input::placeholder {
    color: #92929f !important;
  }

  /* ── Invite page ─────────────────────────────────── */
  .mu-invite {
    padding: 1.5rem 0;
  }

  .mu-invite__page-head {
    margin-bottom: 0rem;
  }

  .mu-invite__back-link {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0;
    margin: 0 0 0.85rem;
    border: none;
    background: transparent;
    color: var(--app-text-muted);
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.15s;
  }

  .mu-invite__back-link:hover {
    color: var(--mu-primary);
  }

  .mu-invite__page-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: var(--app-text);
    margin: 0 0 0.35rem;
    letter-spacing: -0.025em;
    line-height: 1.2;
  }

  .mu-invite__page-subtitle {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--app-text-muted);
    margin: 0;
    line-height: 1.55;
    max-width: 38rem;
  }

  .mu-invite__grid {
    margin-top: 0.5rem;
  }

  .mu-invite__section-card {
    // border: 1px solid var(--app-border);
    // border-radius: var(--mu-radius);
    // background: var(--app-surface);
    // box-shadow: var(--mu-shadow);
    // overflow: hidden;
  }

  .mu-invite__section-header {
    padding: 1rem 1.5rem;
    background: var(--app-surface);
  }

  .mu-invite__section-header-inner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .mu-invite__section-header-inner--wide {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem 1rem;
  }

  .mu-invite__section-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: var(--app-text);
    margin: 0 0 0.15rem;
    line-height: 1.3;
  }

  .mu-invite__section-desc {
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--app-text-muted);
    margin: 0;
    line-height: 1.45;
  }

  .mu-invite__section-body {
    padding: 1.25rem 1.5rem 1.5rem;
  }

  .mu-invite__section-body--accounts {
    padding-top: 1rem;
  }

  .mu-invite__step {
    width: 40px;
    height: 40px;
    border-radius: 7px;
    background: var(--mu-primary-soft);
    color: var(--mu-primary);
    font-size: 15px;
    font-weight: 800;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mu-invite__divider {
    height: 1px;
    background: var(--app-border-soft);
    margin: 1.5rem 0;
  }

  .mu-invite__active-badge {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--mu-primary);
    padding: 0.3rem 0.65rem;
    border-radius: 999px;
    background: var(--mu-primary-soft);
    border: 1px solid var(--mu-primary-border);
    white-space: nowrap;
  }

  .mu-invite__label {
    display: block;
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--app-text);
    margin-bottom: 0.45rem;
  }

  .mu-invite__input.ant-input,
  .mu-invite__input.ant-input-affix-wrapper {
    background: var(--app-surface-alt) !important;
    border: 1px solid var(--app-border) !important;
    color: var(--app-text) !important;
    border-radius: 0.5rem !important;
    font-weight: 500;
    // font-size: 0.875rem;
    min-height: 42px;
    transition: border-color 0.15s, box-shadow 0.15s;
  }

  .mu-invite__input.ant-input::placeholder {
    color: var(--app-text-muted) !important;
    font-weight: 400;
    opacity: 0.9;
  }

  .mu-invite__input.ant-input:hover {
    border-color: color-mix(in srgb, var(--mu-primary) 40%, var(--app-border)) !important;
  }

  .mu-invite__input.ant-input:focus,
  .mu-invite__input.ant-input-focused {
    border-color: var(--mu-primary) !important;
    box-shadow: 0 0 0 3px var(--mu-primary-soft) !important;
  }

  [data-bs-theme="dark"] & .mu-invite__input.ant-input {
    color: #ffffff !important;
  }

  [data-bs-theme="dark"] & .mu-invite__input.ant-input::placeholder {
    color: #92929f !important;
  }

  .mu-invite__input--readonly.ant-input[disabled] {
    color: var(--app-text-muted) !important;
    background: var(--app-surface) !important;
    cursor: not-allowed;
    opacity: 0.9;
  }

  .mu-invite__roles {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
  }

  @media (max-width: 991.98px) {
    .mu-invite__roles {
      grid-template-columns: 1fr;
    }
  }

  .mu-invite__role-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding: 1rem 0.9rem 0.95rem;
    min-height: 4.25rem;
    border: 1.5px solid var(--app-border);
    border-radius: 0.65rem;
    background: var(--app-surface);
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s, transform 0.15s;
  }

  .mu-invite__role-card:hover {
    border-color: var(--mu-primary-border);
    background: var(--app-surface-alt);
    transform: translateY(-1px);
  }

  .mu-invite__role-card--active {
    border-color: var(--mu-primary) !important;
    background: color-mix(in srgb, var(--mu-primary) 6%, var(--app-surface)) !important;
    box-shadow: 0 4px 16px rgba(244, 91, 104, 0.12);
  }

  [data-bs-theme="dark"] & .mu-invite__role-card--active {
    background: color-mix(in srgb, var(--mu-primary) 12%, var(--app-surface)) !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }

  .mu-invite__role-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 3.35rem;
    height: 3.35rem;
    border-radius: 0.55rem;
    background: var(--app-surface-alt);
    color: var(--app-text-muted);
    font-size: 1.5rem;
    flex-shrink: 0;
    margin-bottom: 0.65rem;
    transition: background 0.15s, color 0.15s;
  }

  .mu-invite__role-card--active .mu-invite__role-icon {
    background: var(--mu-primary);
    color: #fff;
  }

  .mu-invite__role-name {
    display: block;
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--app-text);
    margin-bottom: 0.2rem;
    line-height: 1.25;
  }

  .mu-invite__role-desc {
    display: block;
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--app-text-muted);
    line-height: 1.45;
  }

  .mu-invite__role-check {
    position: absolute;
    top: 0.65rem;
    right: 0.65rem;
    width: 1.52rem;
    height: 1.52rem;
    border-radius: 50%;
    background: var(--mu-primary);
    color: #fff;
    font-size: 0.7rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(244, 91, 104, 0.35);
  }

  .mu-invite__state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.65rem;
    padding: 2.5rem 1.25rem;
    color: var(--app-text-muted);
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
  }

  .mu-invite__empty-icon {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: var(--app-surface-alt);
    border: 1px dashed var(--app-border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.35rem;
    color: var(--app-text-muted);
    margin-bottom: 0.5rem;
  }

  .mu-invite__accounts {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
  }

  .mu-invite__account {
    border: 1px solid var(--app-border);
    border-radius: 0.75rem;
    background: var(--app-surface);
    overflow: hidden;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  }

  .mu-invite__account--on {
    border-color: rgba(244, 91, 104, 0.35);
    background: #fff8f8;
    box-shadow: none;
  }

  [data-bs-theme="dark"] & .mu-invite__account--on {
    background: color-mix(in srgb, var(--mu-primary) 8%, var(--app-surface));
    border-color: var(--mu-primary-border);
  }

  .mu-invite__account-head {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.9rem 1rem;
    min-height: 4rem;
  }

  .mu-invite__account-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 0;
    flex: 1;
  }

  .mu-invite__account-icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.55rem;
    font-weight: 800;
    font-size: 0.95rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
  }

  .mu-invite__account-icon--on {
    background: var(--mu-primary);
    color: #fff;
    box-shadow: 0 3px 10px rgba(244, 91, 104, 0.25);
  }

  .mu-invite__account-icon--off {
    background: var(--mu-primary-soft);
    color: var(--mu-primary);
  }

  [data-bs-theme="dark"] & .mu-invite__account-icon--off {
    background: var(--mu-primary-soft);
    color: var(--mu-primary);
  }

  .mu-invite__account-name {
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--app-text);
    line-height: 1.25;
  }

  .mu-invite__account-meta {
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--app-text-muted);
    margin-top: 0.1rem;
  }

  .mu-invite__modules-badge {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--mu-primary);
    padding: 0.22rem 0.6rem;
    border-radius: 999px;
    background: rgba(244, 91, 104, 0.08);
    border: 1px solid rgba(244, 91, 104, 0.35);
    white-space: nowrap;
    flex-shrink: 0;
  }

  .mu-invite__off-badge {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--mu-primary);
    padding: 0.22rem 0.6rem;
    border-radius: 999px;
    background: rgba(244, 91, 104, 0.06);
    border: 1px solid rgba(244, 91, 104, 0.28);
    white-space: nowrap;
    flex-shrink: 0;
  }

  .mu-invite__switch.ant-switch {
    min-width: 2.5rem !important;
    height: 1.625rem !important;
    line-height: 1.625rem !important;
    background: #d8d8e0 !important;
    flex-shrink: 0;
    border-radius: 999px !important;
  }

  .mu-invite__switch.ant-switch .ant-switch-handle {
    width: 1.25rem !important;
    height: 1.25rem !important;
    top: 0.1875rem !important;
    inset-inline-start: 0.1875rem !important;
    border-radius: 50% !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.14) !important;
  }

  .mu-invite__switch.ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 1.4375rem) !important;
  }

  .mu-invite__switch.ant-switch-checked {
    background: var(--mu-primary) !important;
  }

  .mu-invite__switch.ant-switch:hover:not(.ant-switch-disabled) {
    background: #c8c8d2 !important;
  }

  .mu-invite__switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
    background: #e04a57 !important;
  }

  [data-bs-theme="dark"] & .mu-invite__switch.ant-switch {
    background: #3f3f4f !important;
  }

  [data-bs-theme="dark"] & .mu-invite__switch.ant-switch:hover:not(.ant-switch-disabled) {
    background: #4a4a5c !important;
  }

  .mu-invite__modules-panel {
    border-top: 1px solid rgba(244, 91, 104, 0.15);
    padding: 0.85rem 1rem 1rem;
    background: #fff8f8;
  }

  [data-bs-theme="dark"] & .mu-invite__modules-panel {
    background: color-mix(in srgb, var(--mu-primary) 6%, var(--app-surface));
    border-top-color: var(--mu-primary-border);
  }

  .mu-invite__modules-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.7rem;
  }

  .mu-invite__modules-heading {
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--app-text-muted);
  }

  .mu-invite__select-all {
    border: none;
    background: transparent;
    color: var(--mu-primary);
    font-size: 0.8125rem;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
    white-space: nowrap;
    transition: opacity 0.15s;
  }

  .mu-invite__select-all:hover {
    opacity: 0.85;
    text-decoration: underline;
  }

  .mu-invite__modules {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  @media (max-width: 575.98px) {
    .mu-invite__modules {
      grid-template-columns: 1fr;
    }
  }

  .mu-invite__module {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.7rem 0.7rem;
    border: 1px solid var(--app-border);
    border-radius: 0.55rem;
    background: var(--app-surface);
    color: var(--app-text-muted);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.12s, background 0.12s, color 0.12s;
  }

  .mu-invite__module i {
    font-size: 1rem;
    line-height: 1;
    flex-shrink: 0;
    color: var(--app-text-muted);
    transition: color 0.12s;
  }

  .mu-invite__module-label {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.3;
    color: var(--app-text);
    flex: 1;
    min-width: 0;
  }

  .mu-invite__module:hover {
    border-color: rgba(244, 91, 104, 0.35);
  }

  .mu-invite__module--checked {
    border-color: var(--mu-primary);
    background: rgba(244, 91, 104, 0.08);
    color: var(--mu-primary);
  }

  .mu-invite__module--checked i {
    color: var(--mu-primary);
  }

  .mu-invite__module-check {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 0.3rem;
    border: 1.5px solid #d8d8e0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6rem;
    flex-shrink: 0;
    background: var(--app-surface);
    color: transparent;
    transition: background 0.12s, border-color 0.12s, color 0.12s;
  }

  .mu-invite__module--checked .mu-invite__module-check {
    background: var(--mu-primary);
    border-color: var(--mu-primary);
    color: #fff;
  }

  .mu-invite__summary-col {
    align-self: flex-start;
    position: sticky;
    top: 1.25rem;
  }

  .mu-invite__summary-sticky {
    z-index: 2;
    width: 100%;
  }

  @media (max-width: 991.98px) {
    .mu-invite__summary-sticky {
      position: static;
    }
  }

  /* ── Summary card ────────────────────────────────── */
  .mu-summary-card {
    border: 1px solid var(--app-border);
    border-radius: var(--mu-radius);
    background: var(--app-surface);
    box-shadow: var(--mu-shadow);
    overflow: hidden;
  }

  .mu-summary-card--embedded {
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }

  .mu-summary-card__hero {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    column-gap: 0.85rem;
    row-gap: 0.35rem;
    padding: 1.15rem 1.25rem 1.1rem;
    background: var(--mu-hero-bg);
    color: #fff;
    align-items: center;
  }

  .mu-summary-card__avatar {
    grid-row: 1 / 3;
    width: 2.65rem;
    height: 2.65rem;
    border-radius: 50%;
    background: var(--mu-primary);
    color: #fff;
    font-weight: 800;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: start;
    box-shadow: 0 4px 14px rgba(244, 91, 104, 0.4);
  }

  .mu-summary-card__hero-text {
    min-width: 0;
    align-self: center;
  }

  .mu-summary-card__hero-title {
    font-size: 1.0625rem;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 0.15rem;
    color: #fff;
  }

  .mu-summary-card__hero-email {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.68);
    word-break: break-all;
    font-weight: 500;
  }

  .mu-summary-card__role-pill {
    grid-column: 3;
    justify-self: start;
    font-size: 0.875rem;
    font-weight: 700;
    padding: 0.22rem 0.6rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.18);
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.92);
    letter-spacing: 0.02em;
  }

  .mu-summary-card__stats {
    display: flex;
    align-items: stretch;
    background: var(--app-surface);
    border-bottom: 1px solid var(--app-border);
  }

  .mu-summary-card__stat {
    flex: 1;
    padding: 0.9rem 0.5rem;
    text-align: center;
  }

  .mu-summary-card__stat-value {
    display: block;
    font-size: 1.625rem;
    font-weight: 800;
    color: var(--app-text);
    line-height: 1.1;
    letter-spacing: -0.02em;
  }

  .mu-summary-card__stat-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: var(--app-text-muted);
    margin-top: 0.3rem;
  }

  .mu-summary-card__stat-divider {
    width: 1px;
    background: var(--app-border);
    margin: 0.7rem 0;
  }

  .mu-summary-card__preview {
    padding: 1rem 1.2rem 0.5rem;
    background: var(--app-surface);
  }

  .mu-summary-card__preview-label {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--app-text-muted);
    margin-bottom: 0.75rem;
  }

  .mu-summary-card__preview-empty {
    font-size: 0.95rem;
    color: var(--app-text-muted);
    font-weight: 500;
    line-height: 1.55;
    padding-bottom: 0.5rem;
  }

  .mu-summary-card__preview-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mu-summary-card__preview-row {
    margin-bottom: 0.75rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px dashed var(--app-border-soft);
  }

  .mu-summary-card__preview-row:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }

  .mu-summary-card__preview-account {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--app-text);
    margin-bottom: 0.4rem;
    min-width: 0;
  }

  .mu-summary-card__preview-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--mu-primary);
    flex-shrink: 0;
  }

  .mu-summary-card__preview-modules {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    padding-left: 0.95rem;
  }

  .mu-summary-card__module-tag {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 0.2rem 0.5rem;
    border-radius: 999px;
    background: var(--app-surface-alt);
    border: 1px solid var(--app-border);
    color: var(--app-text-muted);
  }

  .mu-summary-card__preview-warn {
    font-size: 0.75rem;
    color: var(--mu-primary);
    font-weight: 600;
    padding-left: 0.95rem;
  }

  .mu-summary-card__actions {
    padding: 1.1rem 1.25rem 1.15rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.65rem;
    background: var(--app-surface);
    border-top: 1px solid var(--app-border);
  }

  .mu-summary-card__submit {
    font-size: 0.9375rem;
    min-height: 44px;
    border-radius: 0.55rem;
    box-shadow: 0 4px 14px rgba(244, 91, 104, 0.28);
  }

  .mu-summary-card__submit:disabled {
    opacity: 0.45;
    box-shadow: none;
  }

  .mu-summary-card__cancel {
    display: block;
    width: 100%;
    padding: 0.35rem 0.5rem;
    border: none;
    // background: transparent !important;
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--app-text-muted) !important;
    text-align: center;
    cursor: pointer;
    transition: color 0.15s;
    min-height: auto;
    box-shadow: none !important;
  }

  .mu-summary-card__cancel:hover {
    color: var(--mu-primary) !important;
    // background: transparent !important;
    border: none !important;
  }
`;
